import reduce from 'lodash/reduce';
import { createSelector } from 'reselect';

import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';

import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';
import { TService } from '~/src/features/tariffBuilder/types/TCurrentTariff';

const prepareNames = (services?: TService[]) => {
    if (!services || !services.length) {
        return;
    }

    const names = services.map(service => service.name);

    if (names.length > 1) {
        return `${names.slice(0, names.length - 1).join(', ')}${NBSP}и${NBSP}${names.slice(-1)}`;
    }

    return services[0].name;
};

type TConnectedSubscriptionNames = {
    length: number,
    names?: string,
}

type TEntity = EEntity.onlineCinemas | EEntity.tv;

const selectConnectedSubscriptionsNames = createSelector(
    (state: TInitialState) => state.currentTariff?.services,
    (services) => {
        return reduce<Record<TEntity, { name: string }[] | undefined>, Record<string, TConnectedSubscriptionNames>>(
            {
                onlineCinemas: services?.onlineCinemas,
                tv: services?.tv,
            },
            (result, value, key) => {
                if (value && value.length) {
                    result[key] = {
                        length: value.length,
                        names: prepareNames(value),
                    };
                }

                return result;
            },
            {},
        );
    },
);

export default selectConnectedSubscriptionsNames;
